<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<h1 mat-dialog-title>{{ title }}</h1>
<div class="dialog-message">{{ message }}</div>

<mat-dialog-actions>
  <button mat-button (click)="onClick(false)" tabIndex="1">NO</button>
  <button mat-button (click)="onClick(true)" tabindex="2">YES</button>
</mat-dialog-actions>


